import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');
import { useLightText } from 'common/lib/colors';
import fontFamily from '../data/font-family';

import { Board as BaseBoard } from '../shared/Board';
import { Card } from './Card';
import { List } from './List';

/* eslint-disable indent */
export const BoardLists = styled.div`
  white-space: nowrap;

  ${List} {
    display: inline-block;
    margin-right: 8px;
    vertical-align: top;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const TeamName = styled.h2.attrs({
  title: ({ children }) => children,
})`
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: normal;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BoardName = styled.h1.attrs({
  title: ({ children }) => children,
})`
  font-family: ${fontFamily};
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  & ~ ${BoardLists} {
    margin-top: 8px;
  }

  & ~ ${TeamName} {
    margin-top: 4px;
  }
`;

export const ErrorMessage = BoardName.extend`
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
`;

export const Board = BaseBoard.extend`
  height: 158px;
  background-size: ${({ headerBgColor }) =>
    headerBgColor ? '100% 64px, cover' : 'cover'};
  width: ${({ numLists = 5 }) => `${numLists * 48 + 8}`}px;

  ${({ hasError }) => (hasError ? `background-color: ${colors.N40A};` : '')}

  ${BoardName}, ${TeamName}, ${ErrorMessage} {
    color: ${({ bgColor, hasError, headerBgColor }) => {
      const color = headerBgColor || bgColor || colors['trello-blue-500'];

      return useLightText(color) && !hasError
        ? colors.white
        : colors['near-black'];
    }}
  }

  ${Card} {
    ${({ hasError, loading }) => (hasError || loading) && 'opacity: 0;'}
  }

  ${List} {
    ${({ hasError, loading }) =>
      (hasError || loading) && `background-color: ${colors.N30};`}
  }

  padding: 8px;
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-board/Board.js